module.exports = __webpack_public_path__ + "static/media/p_27_1.42f72240.png";